import Base from './Base';
import App from './App'
import Single from './SinglePage';
import Details from './Details.js';
import SinglePack from './SinglePack';

const routes = {
  // base component (wrapper for the whole application).
  component: Base,
  childRoutes: [
    {
        path: '/',
        component: App
    },
    {
        path:'/room',
        component:Single
    },
    {
      path:'/details',
      component:Details
    },
    {
      path:'/pack',
      component:SinglePack
    }


  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js